interface ChangeCounterProps {
  count: number;
}

export const ChangeCounter = ({ count }: ChangeCounterProps) => {
  return (
    <div className="flex items-baseline gap-1">
      <div className="text-primary text-xs font-normal">SESSION CHANGES:</div>
      <div className="text-primary text-lg font-normal">{count > 0 && `${count}`}</div>
    </div>
  );
};